import Vue from 'vue'
import VueRouter from 'vue-router'
import VueCookies from 'vue-cookies';
import utils from '../assets/js/utils.js';
import store from '@/store';

import LoginLayout from '../views/Login/loginLayout.vue'
import LoginIndex from '../views/Login/login.vue'
import ResetPassword from '../views/Login/resetPassword.vue'
import NewPassword from '../views/Login/newPassword.vue'
import Worker from '../views/Worker/index.vue'
import UserInfo from '../views/UserInfo/index.vue'
import EditPassword from '../views/EditPassword.vue'
import UserManageLayout from '../views/UserManage/index.vue'
import Application from '../views/UserManage/application.vue'
import OperationLog from '../views/UserManage/operationLog.vue'
// import Administrators from '../views/UserManage/administrators.vue'
import UserList from '../views/UserManage/userList.vue'
import WechatSuccess from '../views/Wechat/success.vue'
import WechatError from '../views/Wechat/error.vue'
import Page404 from '../views/Page404.vue'
import NoAuth from '../views/NoAuth.vue'
import ProductList from '../views/Product/list.vue'
// import Producttest from '../views/Product/test.vue' // 新版pdf预览组件测试用页面

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 2022-8-22 页面路由需要添加/schoolcode
const routes = [
  {
    path: '/:schoolcode(\\d+)?/',
    name: 'Redirect',
    redirect: '/:schoolcode(\\d+)?/login',
  },
  {
    path: '/:schoolcode(\\d+)?/login',
    component: LoginLayout,
    title: '登录',
    children: [
      {
        path: '/',
        name: 'LoginIndex',
        component: LoginIndex
      },
      {
        path: '/:schoolcode(\\d+)?/resetPassword',
        name: 'ResetPassword',
        component: ResetPassword
      },
      {
        path: '/:schoolcode(\\d+)?/newPassword',
        name: 'NewPassword',
        component: NewPassword
      },
    ]
  },
  {
    path: '/:schoolcode(\\d+)?/weSuccess',
    name: 'WechatSuccess',
    component: WechatSuccess
  },
  {
    path: '/:schoolcode(\\d+)?/weError',
    name: 'WechatError',
    component: WechatError
  },
  {
    path: '/:schoolcode(\\d+)?/worker',
    name: 'Worker',
    component: Worker,
  },
  {
    path: '/:schoolcode(\\d+)?/userInfo',
    name: 'UserInfo',
    component: UserInfo,
  },
  {
    path: '/:schoolcode(\\d+)?/editPassword',
    name: 'EditPassword',
    component: EditPassword,
  },
  {
    path: '/:schoolcode(\\d+)?/userManage',
    name: 'UserManageLayout',
    component: UserManageLayout,
    redirect: '/:schoolcode(\\d+)?/userManage/userList',
    children: [
      {
        path: '/:schoolcode(\\d+)?/userManage/userList',
        name: 'UserList',
        component: UserList
      },
      {
        path: '/:schoolcode(\\d+)?/userManage/application',
        name: 'Application',
        component: Application
      },
      {
        path: '/:schoolcode(\\d+)?/userManage/operationLog',
        name: 'OperationLog',
        component: OperationLog
      },
      // {
      //   path: '/userManage/administrators',
      //   name: 'Administrators',
      //   component: Administrators
      // },
    ]
  },
  {
    path: '/:schoolcode(\\d+)?/product',
    name: 'ProductList',
    component: ProductList
  },
  // {
  //   path: '/:schoolcode(\\d+)?/product/test',
  //   name: 'Producttest',
  //   component: Producttest
  // },
  {
    path: '/:schoolcode(\\d+)?/noauth',
    name: 'NoAuth',
    component: NoAuth
  },
  {
    path: '*',
    name: 'Page404',
    component: Page404
  }
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 访问productList页面 未登录时跳转登录并携带from参数 登录后回到productList页面
function checkProductList (to, next, code) {
    if (to.path.indexOf("/product") > -1) {
      next( {path: `/${code}/login`, query: { from: window.location.origin+`${to.path}` }})
    } else {
      next(`/${code}/login`)
    }
}

// 路由守卫获取用户信息：命中 localStorage 缓存时直接使用，避免每次切页面都请求 /user/info
// 仅当 appsToken 末尾的 school_id 与缓存中的 school_id 一致时才用缓存，否则重新请求 /user/info
function getUserInfoForGuard () {
  const cached = utils.getUserInfo()
  const appsToken = VueCookies.get("api_token")
  if (cached && appsToken) {
    const parts = String(appsToken).split('_')
    const tokenSchoolId = parts[parts.length - 1]
    const tokenUserId =  parts[parts.length - 2]
    console.log(parts)
    if ((tokenSchoolId && String(cached.school_id) === String(tokenSchoolId)) && (tokenUserId && String(cached.id) === String(tokenUserId))) {
      store.commit('setLoginUserInfo', { userInfo: cached })
      return Promise.resolve({ code: '0000', data: cached })
    }
  }
  return store.dispatch("getLoginUserInfo", { is_append: 1, loginLink: true })
}

router.beforeEach((to, from, next) => {
  utils.setTitle();
  let code = to.params && to.params.schoolcode ? to.params.schoolcode : ''
  let appsToken = VueCookies.get("api_token");
  let isNeedLogin = utils.pathRouteName(to.path)
  if (to.path.indexOf("/product") > -1 && !appsToken) {
    next( {path: `/${code}/login`, query: { from: window.location.origin+`${to.path}` }})
    return
  }
  if (isNeedLogin) {
    if (appsToken) {
      getUserInfoForGuard().then(res => {
        if(res.code == '0000'){
          if(res.data) {
            if(code == res.data.school_code){
              if(to.path.indexOf("/product") > -1){
                if(utils.productAuth.includes(res.data.username)){
                  next()
                } else {
                  next(`/${code}/noauth`)
                }
              }
              
              if(res.data.pwd_force == 1) {
                // 拦截强制修改密码
                if(to.path.indexOf("/newPassword") > -1){
                  next()
                } else{
                  next(`/${code}/newPassword`)
                }
              } else if(res.data.user_type == 1){
                // 拦截是否有用户管理权限
                if(to.path.indexOf('/userManage') > -1){
                  next(`/${code}/worker`)
                } else {
                  next()
                }
              } else {
                next()
              }
            } else {
              if(to.path.indexOf("/login") > -1){
                next()
              } else {
                const serverCode = res.data.school_code
                const newPath = code
                  ? to.path.replace(/^\/\d+/, `/${serverCode}`)
                  : `/${serverCode}${to.path}`
                next({ path: newPath, query: to.query, replace: true })
              }
            }
          }
        } else if(res.code == '2001'){
          if(to.path.indexOf("/login") > -1){
            next()
          } else{
            // next( `/${code}/login`)
            checkProductList(to,next,code)
          }
        }
      })
    } else {
      next()
    }
  } else {
    if (to.path.indexOf("/login") > -1) {
      if(appsToken){
        getUserInfoForGuard().then(res => {
          if(res.code == '0000'){
            if(code == res.data.school_code){
              // 已经登录的用户 访问登录页时url地址带from参数时 判断来源并跳转from地址  
              if (to.query && to.query.from) {
                // 测试环境 全媒体的测试用的qmt66.jiaoyu.cn 需要加上token参数
                if ((process.env.NODE_ENV == 'development' || process.env.VUE_APP_FLAG === 'test') && to.query.from.indexOf(".jiaoyu.cn") > -1) {
                  let deCodeUrl = decodeURIComponent(to.query.from)
                  window.open(`${deCodeUrl}${deCodeUrl.indexOf("?") > -1 ? '&': "?"}api_token=${appsToken}`, "_self")
                } else {
                  window.open(to.query.from, "_self")
                }
              } else {
                next(`/${code}/worker`)
              }
            } else {
              next()
            }
          } else {
            next()
          }
        })
      } else {
        next()
      }
    } else {
      next()
    }
  }
})



export default router
